import Vue from 'vue'
import Vuex from 'vuex'

//vuex得持久化处理
import createLogger from 'vuex/dist/logger' // 修改日志
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)
const debug = process.env.NODE_ENV !== 'production' // 开发环境中为true，否则为false
export default new Vuex.Store({
  state: {
    headIndex:0,
  },
  getters:{
    headIndex: (state) => state.headIndex ,
  },
  mutations: {
    headIndexMutation(state,index){
      state.headIndex = index;
    }
  },
  actions: {
    headIndexAction({ commit },index){
      commit("headIndexMutation",index)
    }
  },
  modules: {
  },
  plugins: debug ? [createLogger(), createPersistedState({ storage: window.sessionStorage })] : [createPersistedState({ storage: window.sessionStorage })],
})
